import clsx from 'clsx'

interface DemandUserWhatsappStatusBadgeProps {
    status: number | null | undefined
}

const STATUS_CONFIG = {
    null: {
        label: 'Not validated via WhatsApp',
        styleClass: 'bg-grey-200 text-grey-800',
    },
    0: {
        label: 'WhatsApp available (not validated)',
        styleClass: 'bg-secondary-100 text-secondary-800',
    },
    1: {
        label: 'WhatsApp validated',
        styleClass: 'bg-secondary-100 text-secondary-800',
    },
    2: {
        label: 'WhatsApp rejected (not this person)',
        styleClass: 'bg-tertiary-100 text-tertiary-800',
    },
} as const

/**
 * Demand User WhatsApp Status Badge Component
 * Displays a colored badge indicating the WhatsApp validation status
 *
 * Status mapping:
 * - null (no record) → "Not validated via WhatsApp" (Gray)
 * - 0 (PENDING) → "WhatsApp available (not validated)" (Green)
 * - 1 (VALIDATED) → "WhatsApp validated" (Green)
 * - 2 (DENIED) → "WhatsApp rejected (not this person)" (Orange)
 */
const DemandUserWhatsappStatusBadge = ({ status }: DemandUserWhatsappStatusBadgeProps) => {
    const normalizedStatus = status ?? null
    const config =
        STATUS_CONFIG[normalizedStatus as keyof typeof STATUS_CONFIG] ?? STATUS_CONFIG.null

    return (
        <span className={clsx('px-2 py-0.5 rounded text-sm font-bold', config.styleClass)}>
            {config.label}
        </span>
    )
}

export default DemandUserWhatsappStatusBadge
